<template>
  <div class="qh-page reports-page">
    <header class="admin-header">
      <div>
        <span class="admin-kicker">Administración</span>
        <h1>Centro de reportes</h1>
        <p>Descarga información de monitoreo, accesos y usuarios desde un solo lugar.</p>
      </div>

      <div class="summary-cards">
        <div class="summary-card">
          <strong>3</strong>
          <span>Reportes</span>
        </div>
        <div class="summary-card">
          <strong>XLSX</strong>
          <span>Formato</span>
        </div>
      </div>
    </header>

    <section class="action-guide">
      <strong>Acciones disponibles</strong>
      <span><i class="bi bi-calendar3"></i> Seleccionar periodo</span>
      <span><i class="bi bi-check2-square"></i> Todos los meses</span>
      <span><i class="bi bi-download"></i> Descargar Excel</span>
    </section>

    <section class="reports-toolbar">
      <button class="report-tab active" type="button">
        <i class="bi bi-file-earmark-spreadsheet"></i>
        <span>Reportes disponibles</span>
        <span class="tab-count">3</span>
      </button>
    </section>

    <section class="reports-panel">
      <div class="reports-grid">
        <article class="report-card featured-report">
          <div class="report-card-top">
            <span class="report-icon"><i class="bi bi-file-earmark-excel"></i></span>
            <span class="report-badge">Con filtros</span>
          </div>

          <div class="report-copy">
            <span class="report-type">Monitoreo</span>
            <h2>Reporte de Monitoreo por Usuario</h2>
            <p>Seguimiento de accesos realizados por los usuarios a la plataforma durante un periodo seleccionado.</p>
          </div>

          <div class="filter-box">
            <div class="filter-heading">
              <strong>Periodo del reporte</strong>
              <span>Selecciona el año y mes que deseas consultar.</span>
            </div>

            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label for="anio" class="form-label">Año</label>
                <select id="anio" v-model="anio" class="form-select" required>
                  <option value="0" disabled>-- Seleccionar año --</option>
                  <option v-for="year in anios" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label for="mes" class="form-label">Mes</label>
                <select id="mes" v-model="mes" :disabled="checkMes" class="form-select" required>
                  <option value="0" disabled>-- Seleccionar mes --</option>
                  <option v-for="(nombre, index) in meses" :key="index" :value="index + 1">{{ nombre }}</option>
                </select>
              </div>
            </div>

            <label class="all-months-control">
              <input type="checkbox" v-model="checkMes">
              <span>
                <strong>Todos los meses</strong>
                <small>Incluye el año completo seleccionado.</small>
              </span>
            </label>
          </div>

          <button
            v-if="!CargaReporte"
            class="download-button"
            type="button"
            :disabled="!canDownloadMonitoring"
            @click="descargarExcel"
          >
            <i class="bi bi-download"></i>
            <span>Descargar monitoreo</span>
          </button>
          <div v-else class="download-loading"><Spinner /><span>Generando archivo...</span></div>
        </article>

        <article class="report-card">
          <div class="report-card-top">
            <span class="report-icon"><i class="bi bi-file-earmark-excel"></i></span>
            <span class="report-badge neutral">Descarga directa</span>
          </div>

          <div class="report-copy">
            <span class="report-type">Accesos</span>
            <h2>Reporte de Accesos</h2>
            <p>Listado consolidado de accesos por usuario, perfil y categoría habilitada.</p>
          </div>

          <div class="report-information">
            <div><i class="bi bi-person-badge"></i><span>Usuarios y perfiles</span></div>
            <div><i class="bi bi-grid"></i><span>Categorías asociadas</span></div>
            <div><i class="bi bi-file-earmark-spreadsheet"></i><span>Formato Excel</span></div>
          </div>

          <button v-if="!CargaReporte1" class="download-button" type="button" @click="DescargarExcelAccesos">
            <i class="bi bi-download"></i>
            <span>Descargar accesos</span>
          </button>
          <div v-else class="download-loading"><Spinner /><span>Generando archivo...</span></div>
        </article>

        <article class="report-card">
          <div class="report-card-top">
            <span class="report-icon"><i class="bi bi-file-earmark-excel"></i></span>
            <span class="report-badge neutral">Descarga directa</span>
          </div>

          <div class="report-copy">
            <span class="report-type">Usuarios</span>
            <h2>Reporte de Usuarios</h2>
            <p>Listado de usuarios registrados y los perfiles que tienen actualmente asignados.</p>
          </div>

          <div class="report-information">
            <div><i class="bi bi-people"></i><span>Usuarios registrados</span></div>
            <div><i class="bi bi-shield-check"></i><span>Perfiles asignados</span></div>
            <div><i class="bi bi-file-earmark-spreadsheet"></i><span>Formato Excel</span></div>
          </div>

          <button v-if="!CargaReporte2" class="download-button" type="button" @click="DescargarExcelAccesosxUsuarios">
            <i class="bi bi-download"></i>
            <span>Descargar usuarios</span>
          </button>
          <div v-else class="download-loading"><Spinner /><span>Generando archivo...</span></div>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import Spinner from '@/components/Spinners/Spinner.vue';

export default {
  components: { Spinner },
  name: 'PowerbyReporteBI',
  data() {
    return {
      progreso: 0,
      anio: '0',
      mes: '0',
      mostrarBotonDescarga: false,
      anios: Array.from({ length: new Date().getFullYear() - 2010 + 1 }, (_, i) => new Date().getFullYear() - i),
      meses: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
      checkMes: false,
      CargaReporte: false,
      CargaReporte1: false,
      CargaReporte2: false
    };
  },
  computed: {
    canDownloadMonitoring() {
      return this.anio !== '0' && (this.checkMes || this.mes !== '0');
    }
  },
  watch: {
    checkMes(value) {
      if (value) this.mes = '0';
    }
  },
  methods: {
    descargarExcel() {
      if (!this.canDownloadMonitoring) return;
      this.CargaReporte = true;
      this.progreso = 0;

      this.axios.get(`ReportesBI/ReporteBi`, {
        params: { anio: this.anio, mes: this.mes, checkMes: this.checkMes },
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.total) {
            this.progreso = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          }
        }
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Reporte_Monitoreo_${this.anio}_${this.mes}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.checkMes = false;
          this.anio = '0';
          this.mes = '0';
        })
        .catch(error => {
          console.error('Error al conectar con la API o durante la descarga:', error);
        })
        .finally(() => {
          this.CargaReporte = false;
          this.progreso = 0;
        });
    },

    DescargarExcelAccesos() {
      this.CargaReporte1 = true;
      this.axios.get(`ReportesBI/ReporteUsuario`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Reporte_Accesos.xlsx`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          console.error('Error al conectar con la API o durante la descarga:', error);
        })
        .finally(() => {
          this.CargaReporte1 = false;
        });
    },

    DescargarExcelAccesosxUsuarios() {
      this.CargaReporte2 = true;
      this.axios.get(`ReportesBI/ReporteUsuarioXacceso`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Reporte_Usuarios.xlsx`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          console.error('Error al conectar con la API o durante la descarga:', error);
        })
        .finally(() => {
          this.CargaReporte2 = false;
        });
    },
  }
};
</script>

<style scoped>
.reports-page { display: grid; gap: .85rem; }
.admin-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 1rem; }
.admin-kicker { display: block; margin-bottom: .35rem; color: var(--qhatu-primary); font-size: .72rem; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
.admin-header h1 { margin: 0; color: var(--qhatu-text); font-size: clamp(1.7rem, 2.8vw, 2.2rem); font-weight: 800; }
.admin-header p { margin: .35rem 0 0; color: var(--qhatu-muted); }
.summary-cards { display: flex; gap: .55rem; }
.summary-card { min-width: 88px; min-height: 64px; padding: .65rem .8rem; border: 1px solid var(--qhatu-border); border-radius: 14px; background: #fff; display: grid; place-items: center; text-align: center; }
.summary-card strong { color: var(--qhatu-primary); font-size: 1.05rem; }
.summary-card span { color: var(--qhatu-muted); font-size: .72rem; }
.action-guide { display: flex; align-items: center; gap: .95rem; flex-wrap: wrap; min-height: 42px; padding: .55rem .8rem; border: 1px solid var(--qhatu-border); border-radius: 12px; background: #fff; font-size: .78rem; color: #5c6d82; }
.action-guide strong { color: var(--qhatu-text); }
.action-guide span { display: inline-flex; align-items: center; gap: .35rem; }
.action-guide i { color: var(--qhatu-primary); }
.reports-toolbar { display: flex; }
.report-tab { min-height: 48px; padding: .65rem 1rem; border: 1px solid var(--qhatu-border); border-radius: 14px; background: #fff; color: #5f6f84; display: inline-flex; align-items: center; gap: .55rem; font-weight: 750; }
.report-tab.active { color: #fff; background: var(--qhatu-primary); border-color: var(--qhatu-primary); box-shadow: 0 8px 18px rgba(11, 93, 183, .18); }
.tab-count { min-width: 25px; height: 25px; padding: 0 .4rem; border-radius: 999px; background: rgba(255,255,255,.18); display: grid; place-items: center; font-size: .72rem; }
.reports-panel { padding: 1rem; border: 1px solid var(--qhatu-border); border-radius: 16px; background: #fff; box-shadow: 0 12px 30px rgba(22,48,76,.06); }
.reports-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 1rem; align-items: stretch; }
.report-card { min-height: 100%; padding: 1.15rem; border: 1px solid #dce6f0; border-radius: 16px; background: linear-gradient(180deg, #fff, #fbfdff); display: flex; flex-direction: column; gap: 1rem; box-shadow: 0 10px 24px rgba(31, 52, 79, .06); }
.report-card.featured-report { border-color: #b9d2ec; box-shadow: 0 12px 28px rgba(11, 93, 183, .10); }
.report-card-top { display: flex; align-items: center; justify-content: space-between; gap: .75rem; }
.report-icon { width: 50px; height: 50px; border-radius: 14px; display: grid; place-items: center; background: #e8f7f0; color: #11875f; font-size: 1.55rem; }
.report-badge { padding: .35rem .6rem; border-radius: 999px; background: #eaf3fc; color: var(--qhatu-primary); font-size: .7rem; font-weight: 750; }
.report-badge.neutral { background: #f1f4f8; color: #66778c; }
.report-copy { min-height: 128px; }
.report-type { color: var(--qhatu-primary); font-size: .68rem; font-weight: 800; letter-spacing: .09em; text-transform: uppercase; }
.report-copy h2 { margin: .4rem 0 .5rem; color: #17283f; font-size: 1.05rem; line-height: 1.35; font-weight: 800; }
.report-copy p { margin: 0; color: var(--qhatu-muted); font-size: .84rem; line-height: 1.55; }
.filter-box { padding: .9rem; border: 1px solid #dce7f2; border-radius: 14px; background: #f8fbfe; }
.filter-heading { display: grid; gap: .15rem; margin-bottom: .75rem; }
.filter-heading strong { color: #27384f; font-size: .88rem; }
.filter-heading span { color: var(--qhatu-muted); font-size: .75rem; }
.form-label { margin-bottom: .35rem; color: #465a72; font-size: .75rem; font-weight: 750; }
.form-select { min-height: 44px; border-radius: 10px; }
.all-months-control { margin-top: .8rem; padding: .7rem; border-radius: 11px; background: #fff; display: flex; align-items: flex-start; gap: .55rem; cursor: pointer; }
.all-months-control input { margin-top: .2rem; }
.all-months-control span { display: grid; gap: .08rem; }
.all-months-control strong { color: #30445d; font-size: .82rem; }
.all-months-control small { color: var(--qhatu-muted); font-size: .72rem; }
.report-information { display: grid; gap: .55rem; margin: auto 0; padding: .9rem; border-radius: 14px; background: #f8fafc; }
.report-information div { display: flex; align-items: center; gap: .5rem; color: #5b6d84; font-size: .8rem; }
.report-information i { color: var(--qhatu-primary); }
.download-button { width: 100%; min-height: 48px; margin-top: auto; border: 0; border-radius: 12px; background: #198b59; color: #fff; display: inline-flex; align-items: center; justify-content: center; gap: .55rem; font-weight: 750; transition: transform .18s, background .18s; }
.download-button:hover:not(:disabled) { background: #11754a; transform: translateY(-1px); }
.download-button:disabled { opacity: .55; cursor: not-allowed; }
.download-loading { min-height: 48px; margin-top: auto; display: flex; align-items: center; justify-content: center; gap: .55rem; color: #5f6f84; font-size: .8rem; }
@media (max-width: 1100px) { .reports-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 767.98px) {
  .admin-header { align-items: flex-start; flex-direction: column; }
  .summary-cards { width: 100%; }
  .summary-card { flex: 1; }
  .action-guide { align-items: flex-start; }
  .reports-panel { padding: .75rem; }
  .reports-grid { grid-template-columns: 1fr; }
  .report-copy { min-height: auto; }
}
</style>
